var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showProgress)?_c('navigation-progress-bar',{staticClass:"program-enrolment-progress",attrs:{"current-page":_vm.currentPage,"max-page":_vm.progressPages.length - 1}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }